import React from 'react'

const UserCollections = () => {
    return (
        <div>UserCollections</div>
    )
}

export default UserCollections